// 引入拦截器
import axios from '@/utils/fetch'
import {HttpResp} from "../constant";

// 声明基础访问地址
axios.defaults.baseURL = HttpResp.BASE_URL

/**
 * 查询分页
 * @returns {*}
 */
export function getBrief() {
  return axios.get('/tour/location/brief').then(res => res.data);
}
/**
 * 删除头像
 * @returns {*}
 */
export function getDetail() {
  return axios.get('/tour/location/detail').then(res => res.data);
}
/**
 * 查询分页
 * @returns {*}
 */
export function listGroup() {
  return axios.get('/system/tour/group/list').then(res => res.data);
}
/**
 * 查询分页
 * @param groupId
 * @returns {*}
 */
export function listLocation(groupId) {
  return axios.get('/system/tour/location/list/' + groupId).then(res => res.data);
}
/**
 * 保存定位
 * @param groupId
 * @param data
 * @returns {*}
 */
export function saveLocation(groupId, data) {
  return axios.post('/system/tour/location/save/' + groupId, data).then(res => res.data);
}
/**
 * 保存组
 * @param data
 * @returns {*}
 */
export function saveGroup(data) {
  return axios.post('/system/tour/group/save', data).then(res => res.data);
}
/**
 * 删除组
 * @param groupId
 * @returns {*}
 */
export function delGroup(groupId) {
  return axios.post('/system/tour/group/del/' + groupId).then(res => res.data);
}
/**
 * 查询省份列表
 * @returns {*}
 */
export function listProvince() {
  return axios.get('/system/tour/group/listProvince').then(res => res.data);
}



// WEBPACK FOOTER //
// ./src/api/tour.js